import React, { useEffect } from "react";
import { motion, useAnimation } from "framer-motion";
import { useInView } from "react-intersection-observer";

// Word wrapper
const Wrapper = (props) => {
  // We'll do this to prevent wrapping of words using CSS
  return <span className="word-wrapper">{props.children}</span>;
};

// Map API "type" values to JSX tag names
const tagMap = {
  container: "div",
};

// AnimatedCharacters
// Handles the deconstruction of each word and character to setup for the
// individual character animations

const AnimatedCharacters = (props) => {
  const { ref, inView } = useInView();
  const animationControl = useAnimation();

  useEffect(() => {
    if (inView) {
      // if (props.delay) {
      setTimeout(() => {
        animationControl.start("visible");
      }, props.delay);
      // } else {
      // animationControl.start("visible");
      // }
    }
  }, [inView, animationControl]);

  // Framer Motion variant object, for controlling animation
  const item = {
    hidden: {
      y: "200%",
      // color: "#2e2d2d",
      opacity: 0,
      transition: { ease: [0.455, 0.03, 0.515, 0.955], duration: 0.75 },
    },
    visible: {
      y: 0,
      // color: "#2e2d2d",
      opacity: 1,
      transition: { ease: [0.455, 0.03, 0.515, 0.955], duration: 0.85 },
    },
  };

  //  Split each word of props.text into an array
  const splitWords = props.text.split(" ");

  // Create storage array
  const words = [];

  // Push each word into words array
  for (const [, item] of splitWords.entries()) {
    words.push(item.split(""));
  }

  // Add a space ("\u00A0") to the end of each word
  words.map((word) => {
    return word.push("\u00A0");
  });

  // Get the tag name from tagMap
  const Tag = tagMap[props.type];

  return (
    <Tag>
      {words.map((word, index) => {
        return (
          // Wrap each word in the Wrapper component
          <Wrapper key={index}>
            {words[index].flat().map((element, index) => {
              return (
                <span
                  style={{
                    overflow: "hidden",
                    display: "inline-block",
                  }}
                  x
                  viewport={{ once: true }}
                  key={index}
                  ref={ref}
                >
                  <motion.span style={{ display: "inline-block" }} variants={item} initial="hidden" animate={animationControl}>
                    {element}
                  </motion.span>
                </span>
              );
            })}
          </Wrapper>
        );
      })}
    </Tag>
  );
};

export default AnimatedCharacters;
